import React from 'react';
import style from './RelatedContentIcons.scss';

export const RelatedContentIcons = ({ iconName }) =>
  (relatedContentIcons[iconName] && (
    <span data-hook={`${iconName}`}>{relatedContentIcons[iconName]}</span>
  )) ||
  null;

const relatedContentIcons = {
  video: (
    <svg
      className={style.videoSvg}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
    >
      <g fill="none" fillRule="evenodd" stroke="#0059FF">
        <circle cx="7" cy="7" r="6.5" />
        <path d="M9.118 7L5.5 8.809V5.191L9.118 7z" />
      </g>
    </svg>
  ),
  example: (
    <svg
      className={style.example}
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="7"
      viewBox="0 0 14 7"
    >
      <path
        fill="#0059FF"
        fillRule="evenodd"
        d="M8 .003h1L6 7H5L8 .003zM4 6h-.252L0 3.79l.003-.581L3.748 1H4v1L1.508 3.5 4 5v1zm6 0V5l2.492-1.5L9.999 2V1h.252l3.747 2.209.002.58L10.251 6H10z"
      />
    </svg>
  ),

  article: (
    <svg
      className={style.articleSvg}
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="11"
      viewBox="0 0 8 11"
    >
      <path
        fill="#669BFF"
        fillRule="evenodd"
        d="M1 0h6a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm0 1v9h6V1H1zm1 2h4v1H2V3zm0 2h4v1H2V5zm0 2h4v1H2V7z"
      />
    </svg>
  ),
};
